import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "nav" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  alt: "logo",
  src: "/logo.png",
  height: "40",
  class: "p-mr-2"
}, null, -1)

export function render(_ctx, _cache) {
  const _component_Button = _resolveComponent("Button")
  const _component_Menubar = _resolveComponent("Menubar")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Menubar, { model: _ctx.items }, {
      start: _withCtx(() => [
        _hoisted_2
      ]),
      end: _withCtx(() => [
        _createVNode(_component_Button, {
          icon: "pi pi-user",
          label: _ctx.currentUser.name,
          class: "p-button-rounded p-button-info",
          onClick: _ctx.changePassword
        }, null, 8, ["label", "onClick"])
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}